import React, { Component } from 'react'
import { connect } from 'react-redux'
import yup from 'yup'

import Button from 'components/button/button'
import Loader from 'components/loader/loader'
import { passwordReset } from 'state/actions'
import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import SmoothCollapse from 'react-smooth-collapse'

class PasswordReset extends Component {
	state = {
		currentPassword: '',
		password: '',
		confirmPassword: '',
		isLoading: false,
	}

	updateField = e => {
		this.setState({
			[e.target.name]: e.target.value,
		})
	}

	handleFormSubmit = async _ => {
		const schemaShape = {
			confirmPassword: yup.string().oneOf([yup.ref('password'), null], `These passwords don't match.`).required('Password confirm is required'),
			password: yup.string().min(8, 'Your new password must be at least 8 characters').required('Please enter a new password'),
		}

		if(!this.props.isEditingOtherUser){
			schemaShape.currentPassword = yup.string().required('Please enter your current password')
		}

		const passwordSchema = yup.object().shape(schemaShape)

	    try {
	    	await passwordSchema.validate({ ...this.state })
	    } catch (error) {
	    	return this.props.handleError(error.message)
	    }

	    this.setState({
	    	isLoading: true,
	    })

		const { 
			currentPassword, 
			password 
		} = this.state

		const {
			userData
		} = this.props
		
	    this.props.passwordReset({ currentPassword, password, user: userData }, (error, response) => {
	    	if (error) {
	    		this.setState({
	    			isLoading: false,
	    		})
	    		return this.props.handleError(error.message)
	    	}

	    	if (response.ok) {
	    		this.setState({
	    			isLoading: false,
	    			currentPassword: '',
	    			password: '',
	    			confirmPassword: '',
				})

				const successMessage = this.props.isEditingOtherUser ? this.props.userData.first_name+"'s password has been reset." : "Your password has been reset."
				
	    		this.props.handleSuccess(successMessage)
	    	}
	    })
	}

	render() {
		const {
			isEditingOtherUser,
			validateResponse,
			handleDismiss,
			closeCallback
		} = this.props

		const {
			isLoading,
			currentPassword,
			password,
			confirmPassword
		} = this.state

		return (
			<div>
				<Loader 
					visible={isLoading} 
					noText={true} 
				/>
				<form 
					onSubmit={e => e.preventDefault()} 
					noValidate 
					className="register-container auth-fields"
				>
					<div className="form-fields password-reset-form">
						<SmoothCollapse expanded={!!validateResponse}>
							<ValidateResponse 
								dismissCallback={handleDismiss} 
								response={validateResponse} 
								timeout={5000} 
								isAtTop={true}
							/>
						</SmoothCollapse>
						{ !isEditingOtherUser &&
							<div className="form-row">
								<input 
									value={currentPassword} 
									onChange={e => this.updateField(e)} 
									placeholder="Current Password" 
									name="currentPassword" 
									type="password" 
								/>
							</div>
						}
						<input 
							value={password} 
							onChange={e => this.updateField(e)} 
							placeholder="New Password" 
							name="password" 
							type="password" 
						/>
						<input 
							value={confirmPassword} 
							onChange={e => this.updateField(e)} 
							placeholder="Confirm new Password" 
							name="confirmPassword" 
							type="password" 
						/>
					</div>
					<Button 
						size={'big'} 
						level={'high'} 
						callback={this.handleFormSubmit} 
						label={'Update password'} 
						icon={'check'} 
					/>
					<Button 
						size={'big'} 
						level={'low'} 
						callback={closeCallback} 
						label={'Cancel'} 
					/>
				</form>
			</div>
		)
	}
}

const PasswordResetWithValidation = withValidateResponse(PasswordReset)

export default connect(null, { passwordReset })(PasswordResetWithValidation)



// WEBPACK FOOTER //
// ./src/components/auth/password-reset.jsx